const CZECH_CITIZENSHIP_CODES = ["CZ", "CZE"];

export const isCzechCitizen = (citizenship: string | null | undefined): boolean =>
    CZECH_CITIZENSHIP_CODES.includes(citizenship?.toUpperCase() ?? "");

const birthNumberFormat = /^(\d{2})(\d{2})(\d{2})(\d{3})(\d?)$/;

// Ported from core-java com.investbay.core.shared.utils.CzechoslovakBirthNumber to keep validation in sync with the backend.
export const isValidCzechoslovakBirthNumber = (value: string | null | undefined): boolean => {
    const onlyDigits = (value ?? "").replace(/\D/g, "");
    const match = birthNumberFormat.exec(onlyDigits);
    if (!match) return false;

    const controlDigit = match[5];
    if (!controlDigit) return true;

    const mod = Number(onlyDigits.slice(0, 9)) % 11;
    return (mod === 10 ? 0 : mod) === Number(controlDigit);
};
